import { render } from "./ServiceOrderUpdate.vue?vue&type=template&id=717d2c06&scoped=true"
import script from "./ServiceOrderUpdate.vue?vue&type=script&lang=js"
export * from "./ServiceOrderUpdate.vue?vue&type=script&lang=js"

import "./ServiceOrderUpdate.vue?vue&type=style&index=0&id=717d2c06&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717d2c06"]])

export default __exports__